<template>
  <div class="short-answer">
    <div class="sa-header clearfix">
      <div class="toolbar">
        <div class="fl">
          <!-- <slot name="header-num"></slot> -->
          第{{currentQuestionIndex + 1}}题
        </div>
        <div class="fr">
          <slot name="header-func"></slot>
          <a href="javascript:void(0)"
             @click="signTextFn"><i class="icon-flag"></i>标记文字</a>
          <a href="javascript:void(0)"
             @click="cancelSignFn"><i class="icon-flag-c"></i>取消标记</a>
          <a href="javascript:void(0)"
             v-if="frameStatus"
             @click="resetTop('top')"><i class="icon-zoom-out" />{{magnifyText }}</a>
          <a href="javascript:void(0)"
             v-else
             @click="toggleWin('top')"><i class="icon-zoom-in" />{{ magnifyText }}</a>

        </div>
      </div>
    </div>

    <div class="sa-content"
         ref="content"
         :style="{ height : contentHeight }"
         v-html="currentQuestion.content"></div>
    <div class="sa-function clearfix"
         v-if="currentQuestion.quesTypeID === 4 || currentQuestion.quesTypeID === 5">
      <ul class="fr">
        <li><a href="javascript:void(0)"
             @click="copyFn"><i class="icon-copy" />复制</a></li>
        <li><a href="javascript:void(0)"
             @click="cutFn"><i class="icon-cut" />剪切</a></li>
        <li><a href="javascript:void(0)"
             @click="pasteFn"><i class="icon-paste" />粘贴</a></li>
        <!--<li>
          <a href="javascript:void(0)" class="gsjz" @click="visibleTable = true"/>
          <matrix :visible.sync="visibleTable" @toggleTable="insertMatrix" @delTable="deleteTable"/>
        </li>-->
        <li>
          <a href="javascript:void(0)"
             class="gsfh"
             @click="visibleFm = true" />
          <formula :visible.sync="visibleFm"
                   @toggleFn="insertWrite" />
        </li>
        <li>
          <a href="javascript:void(0)"
             @click="visibleIME = true"><i class="icon-ch" />输入法</a>
          <ul class="fn-list"
              v-show="visibleIME"
              @click="IMEAlert"
              @mouseleave="visibleIME = false">
            <li>微软拼音输入法</li>
            <li>谷歌拼音输入法</li>
            <li>搜狗拼音输入法</li>
            <!-- <li>全拼输入法</li>
            <li>搜狗五笔输入法</li> -->
            <li>极品五笔输入法</li>
            <li>万能五笔输入法</li>
            <li>王码五笔输入法</li>
          </ul>
        </li>
        <li><a href="javascript:void(0)"
             @click="runCalc"><i class="icon-cal" />计算器</a></li>
        <li v-if="frameStatus">
          <a href="javascript:void(0)"
             @click="resetTop('bottom')">
            <i class="icon-zoom-out"
               v-if="frameStatus" />{{ magnifyText }}</a>
        </li>
        <li v-else><a href="javascript:void(0)"
             @click="toggleWin('bottom')"><i class="icon-zoom-in" />{{ magnifyText }}</a></li>
        <li><a href="javascript:void(0)"
             @click="visibleHelp=true"><img src="@/assets/images/doExam/help.png" />帮助</a></li>

      </ul>
    </div>
    <div class="sa-input"
         ref="saInput"
         v-if="currentQuestion.quesTypeID === 4 || currentQuestion.quesTypeID === 5">
      <div class="quesContent"
           ref="quesContent">
        <strong>请在下方答题区域内作答。</strong><br />
        <div class="answerArea"
             ref="withoutChildAnswerArea"
             id="answerArea"
             contenteditable="true"
             @mouseup="mouseUpFn"
             :style="{ height:textareaHeight }"
             v-html="currentQuestion.userAnswer">
        </div>
      </div>
    </div>
    <div class="sa-input sa-input-simple"
         ref="saInput"
         v-else>
      <div class="quesContent quesContent-simple"
           ref="quesContent">
        <!-- 单选题、判断题 -->
        <template v-if="currentQuestion.quesTypeID === 1 || currentQuestion.quesTypeID === 3">
          <exam-single-choice ></exam-single-choice>
        </template>
        <!-- 多选题 -->
        <template v-if="currentQuestion.quesTypeID === 2">
          <exam-multiple-choice ></exam-multiple-choice>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Formula from '../formula'
import editor from '@/mixins/editor'
import { ExamSingleChoice, ExamMultipleChoice } from '@components/exam'

export default {
  name: 'WithoutChildQuestion',
  components: {
    Formula,
    ExamSingleChoice,
    ExamMultipleChoice,
  },
  computed: {
    ...mapGetters(['currentQuestionIndex', 'currentQuestion']),
    magnifyText() {
      return this.frameStatus ? '恢复窗口' : '放大窗口'
    },
  },
  mixins: [editor],
  data() {
    return {
      visibleTable: false, // 矩阵显隐
      visibleFm: false, //  公式显隐
      visibleHelp: false, //  帮助弹窗显隐
      visibleIME: false, //  输入法显隐
      frameStatus: false,
      contentHeight: '300px',
      smallIndex: 0,
      textareaHeight: '132px',
      //容器对象
      rangeData: {
        //  鼠标选中数据
        start: 0,
        end: 0,
        text: '',
      },
      editorContainer: null,
      currentFormulaID: '', //  当前正在编辑的公式span的id
      blankSpan:
        '<span class="blankSpan" style="display:inline-block;width:1px;">&nbsp;</span>',
      formulaHtml:
        '<span id="span_formula_{0}" class="isFormula"></span><span id="span_Temp">&nbsp;</span><span class="blankSpan" style="display:inline-block;width:1px;">&nbsp;</span>',
      matrixHtml: '',
      timerMouseUP: null, // mouseUp计时器，光标问题临时解决方案
    }
  },
  mounted() {},
  methods: {
    setCurrentSmallContent() {
      if (
        this.currentQuestion.quesTypeID === 4 ||
        this.currentQuestion.quesTypeID === 5
      ) {
        let domInput = this.$refs['withoutChildAnswerArea']
        let answer = domInput.innerHTML === '<br/>' ? '' : domInput.innerHTML
        let isAnswer = answer ? 1 : 0
        this.$store.dispatch('setUserAns', answer)
        this.$store.dispatch('setIsAns', isAnswer)
      }
    },
  },
}
</script>
